export const iconFontAwesomeWritingSignature = (
	<i className="fa-solid fa-signature"></i>
);
